import { render, staticRenderFns } from "./TestMarkPoint.vue?vue&type=template&id=ad581ad2"
import script from "./TestMarkPoint.vue?vue&type=script&lang=js"
export * from "./TestMarkPoint.vue?vue&type=script&lang=js"
import style0 from "./TestMarkPoint.vue?vue&type=style&index=0&id=ad581ad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports